import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Utils from 'libs/Utils';
import PropTypes from 'prop-types';

import Header from 'components/Header';
import OrderInformation from 'components/OrderInformation';

import './styles.css';
import confirm from './img/confirm.svg';
import deposit from './img/deposit.svg';

class Exchanging extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: false,
    };
  }

  componentWillMount() {
    this.props.infoStore.setPair(
      this.props.exchangeStore.exchange.fromCoin,
      this.props.exchangeStore.exchange.toCoin,
      (error) => {
        this.setState({ error });
      },
    );
  }

  render() {
    const toAmount = (
      (this.props.exchangeStore.exchange.fromAmount *
      this.props.infoStore.rate) - this.props.infoStore.minerFee
    );

    return (
      <div className="exchanging">
        {this.state.error ?
          <div className="error">{this.state.error} <Link className="error__link" to="/">Click here to go back</Link></div>
        : null}

        <Header step={3} light />
        <div className="content">
          <h1 className="title">Your coins are exchanging</h1>

          <ul className="statusses">
            <li className="status status--confirmed">
              <span className="status__icon">
                <img className="status__img" width="15" height="19" src={deposit} alt="Deposit received" />
              </span>
              <span className="status__name">Deposit received</span>
              <img className="status__confirm" width="22" height="16" src={confirm} alt="Confirm" />
            </li>

            <li className="status">
              <span className="status__icon">
                <svg className="status__exchange" xmlns="http://www.w3.org/2000/svg" width="24" height="26" viewBox="0 0 24 26">
                  <g
                    className="status__exchange-left-arrow"
                    fill="none"
                    stroke="#fff"
                    strokeLinecap="round"
                    strokeWidth="2"
                  >
                    <path strokeMiterlimit="10" d="m4 6h16" />
                    <path strokeLinejoin="round" d="m15 1l5 5-5 5" />
                  </g>
                  <g
                    className="status__exchange-right-arrow"
                    fill="none"
                    stroke="#fff"
                    strokeLinecap="round"
                    strokeWidth="2"
                  >
                    <path strokeMiterlimit="10" d="m20 20h-16" />
                    <path strokeLinejoin="round" d="m9 25l-5-5 5-5" />
                  </g>
                </svg>
              </span>
              <span className="status__name">Awaiting exchange</span>
            </li>
          </ul>

          <div className="estimate">
            <span className="estimate__pulsate" />
            {`Approximately ${Utils.coinNumberFormat(toAmount, 2)} ${this.props.exchangeStore.exchange.toCoin.name} will be sent to your wallet.`}
          </div>

          <OrderInformation exchangeStore={this.props.exchangeStore} />
        </div>
      </div>
    );
  }
}

Exchanging.propTypes = {
  infoStore: PropTypes.object.isRequired,
  exchangeStore: PropTypes.object.isRequired,
};

export default Exchanging;



// WEBPACK FOOTER //
// ./src/scenes/Exchange/scenes/Exchanging/index.jsx